/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * KoboToolbox Primary API
 * This page documents all KoboToolbox API endpoints, except for those implementing the OpenRosa protocol, which are [documented separately](/api/openrosa/docs/).

The endpoints are grouped by area of intended use. Each category contains related endpoints, with detailed documentation on usage and configuration. Use this as a reference to quickly find the right endpoint for managing projects, forms, data, permissions, integrations, logs, and organizational resources.

**General note**: All projects (whether deployed or draft), as well as all library content (questions, blocks, templates, and collections) in the user-facing application are represented in the API as "assets".
 * OpenAPI spec version: 2.0.0 (api_v2)
 */

/**
 * * `automatic_google_transcription` - automatic_google_transcription
 * `automatic_google_translation` - automatic_google_translation
 * `manual_transcription` - manual_transcription
 * `manual_translation` - manual_translation
 * `manual_qual` - manual_qual
 * `automatic_bedrock_qual` - automatic_bedrock_qual
 */
export type ActionEnum = (typeof ActionEnum)[keyof typeof ActionEnum]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionEnum = {
  automatic_google_transcription: 'automatic_google_transcription',
  automatic_google_translation: 'automatic_google_translation',
  manual_transcription: 'manual_transcription',
  manual_translation: 'manual_translation',
  manual_qual: 'manual_qual',
  automatic_bedrock_qual: 'automatic_bedrock_qual',
} as const
